var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 2C-2.33594 2.5625 -2.33594 27.6875 15.0078 28.25C32.3516 27.6875 32.3516 2.5625 15.0078 2Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.313 15L20.2505 11.0625C21.0942 10.2187 19.7817 8.90625 18.938 9.75L15.0005 13.6875L11.063 9.75C10.2192 8.90625 8.90674 10.2187 9.75049 11.0625L13.688 15L9.75049 18.9375C8.90674 19.7812 10.2192 21.0937 11.063 20.25L15.0005 16.3125L18.938 20.25C19.7817 21.0937 21.0942 19.7812 20.2505 18.9375L16.313 15Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.486641ea3a603200c7c1f64d25351db2.svg";
export { ForwardRef as ReactComponent };